<script>
  import { Telekinesis, Session } from "telekinesis-js";
  // import Editor from "./Editor.svelte";
  import OutputItem from "./OutputItem.svelte";

  export let content;
  
  let expandable;
  let expanded;
  let oldContent;
  $: {
    expandable = content?.length > 10;
    if (JSON.stringify(content?.slice(0, oldContent?.length)) != JSON.stringify(oldContent)) {
      oldContent = content;
      expanded = false;
    }
  }

</script>


{#if content}
      <div style='background-color:#333d;border-radius: 5px; font-family:monospace; padding:5px; overflow:auto; ' >
        {#if !expandable || expanded}
          {#if expandable}
            <span class='collapse' on:click={() => {expanded = false}}>
              {'▼'}
            </span>
          {/if}
          {#each content as [type, message, tempSessionKey]}
            <p style="text-align:left;color:{type !== 'error' ? '#eee' : '#d33'}">
              {#if message[0] && typeof message[0] === 'string'}
                <OutputItem item={message} indent={expandable}/>
              {:else}
                {#each (message || []) as m}
                  <!-- {console.log(m) || console.log('>', new Telekinesis(undefined, new Session())._decode(m) ) || ''} -->
                  <OutputItem item={new Telekinesis(undefined, new Session())._decode(m)} session={tempSessionKey} indent={expandable}/>
                {/each}
              {/if}
            </p>
          {/each}
        {:else}
          <span class='collapse' on:click={() => {expanded = true}}>
            {'▶'} <OutputItem item={`long output ... (${content.length} items)`}/>
          </span>
        {/if}
      </div> 
{/if}

<style>
  .collapse {
    cursor: pointer;
    color: #bbb;
    width: 100%;
    display: block;
    text-align: left;
  }
</style>
